// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"773b8b842e250caefec3","655":"c2a79f3e8ac4a2c08528"}[chunkId] + ".js";
};